import React from 'react';
import styles from './index.module.scss';
import { useScrollTrigger } from '@/hooks/useScrollTrigger';

// 第三屏：爱学—AI一对一教育产品四大特点
export default function Screen3() {
  const rootRef = useScrollTrigger({
    triggerClass: styles['screen3-anim-start'],
    triggerRatio: 0.5,
    scrollContainerSelector: '.aixue-home-scroll',
    enableResizeDetection: true
  });

  return (
    <section className={styles['screen3-cover']} ref={rootRef}>
      <div className={styles['screen3-wrap']}>
        {/* 标题 */}
        <div className={styles['screen3-title-wrap']}>
          <h2 className={styles['screen3-title']}>产品四大特点</h2>
        </div>

        <div className={styles['screen3-cards']}>
          <div className={`${styles['screen3-card']} ${styles['screen3-card1']}`}>
            <div className={styles['screen3-icon-eng']}></div>
            <div className={styles['screen3-icon']}></div>
            <div className={styles['screen3-card-text']}>
              <div>3分钟一次开口</div>
              <div>学习专注不走神</div>
            </div>
            <div className={styles['screen3-card-text-desc']}>
              坚信短时高频互动是学习效果的核心保障
            </div>
          </div>

          <div className={`${styles['screen3-card']} ${styles['screen3-card2']}`}>
            <div className={styles['screen3-icon-eng']}></div>
            <div className={styles['screen3-icon']}></div>
            <div className={styles['screen3-card-text']}>
              <div>问题答错无压力</div>
              <div>AI导师更耐心</div>
            </div>
            <div className={styles['screen3-card-text-desc']}>
              创造零压力试错环境，保护学习自信心
            </div>
          </div>

          <div className={`${styles['screen3-card']} ${styles['screen3-card3']}`}>
            <div className={styles['screen3-icon-eng']}></div>
            <div className={styles['screen3-icon']}></div>
            <div className={styles['screen3-card-text']}>
              <div>学习内容个性化</div>
              <div>AI授课一对一</div>
            </div>
            <div className={styles['screen3-card-text-desc']}>
              拒绝标准化灌输，尊重每个学习者的独特性
            </div>
          </div>

          <div className={`${styles['screen3-card']} ${styles['screen3-card4']}`}>
            <div className={styles['screen3-icon-eng']}></div>
            <div className={styles['screen3-icon']}></div>
            <div className={styles['screen3-card-text']}>
              <div>AI导师方法好</div>
              <div>真人辅助效果好</div>
            </div>
            <div className={styles['screen3-card-text-desc']}>
              融合AI算法与真人教育智慧，实现教学最优解
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
